import api from 'utils/apiClient';

export const getPlainBusinessLines = () => {
  return api.get('/business_lines', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 10000,
    },
  });
};

export const getBusinessLines = (params) => {
  return api.get('/business_lines', { params });
};

export const createBusinessLine = (data) => {
  return api.post('/business_lines', data);
};

export const editBusinessLine = (id, data) => {
  return api.patch(`/business_lines/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};

export const deleteBusinessLine = (id) => {
  if (Array.isArray(id)) {
    return api.delete(`/business_lines/bulk_delete?items=${id.join(',')}`);
  } else {
    return api.delete(`/business_lines/${id}`);
  }
};

export const getPlainInterests = () => {
  return api.get('/interests', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 10000,
    },
  });
};

export const getInterests = (params) => {
  return api.get('/interests', { params });
};

export const createInterest = (data) => {
  return api.post('/interests', data);
};

export const editInterest = (id, data) => {
  return api.patch(`/interests/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};

export const deleteInterest = (id) => {
  if (Array.isArray(id)) {
    return api.delete(`/interests/bulk_delete?items=${id.join(',')}`);
  } else {
    return api.delete(`/interests/${id}`);
  }
};

export const getPlainLanguagesSpoken = () => {
  return api.get('/language_spokens', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 10000,
    },
  });
};

export const getLanguagesSpoken = (params) => {
  return api.get('/language_spokens', { params });
};

export const createLanguageSpoken = (data) => {
  return api.post('/language_spokens', data);
};

export const editLanguageSpoken = (id, data) => {
  return api.patch(`/language_spokens/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};

export const deleteLanguageSpoken = (id) => {
  if (Array.isArray(id)) {
    return api.delete(`/language_spokens/bulk_delete?items=${id.join(',')}`);
  } else {
    return api.delete(`/language_spokens/${id}`);
  }
};

export const getCountries = () => {
  return api.get('/geo/countries', {
    headers: {
      Accept: 'application/json',
    },
  });
};

export const getCities = (params) => {
  return api.get('/geo/cities', {
    params,
    headers: {
      Accept: 'application/json',
    },
  });
};

export const changeCountriesSequence = (params) => {
  return api.post('/geo/countries', params);
};

export const changeCitiesSequence = (params) => {
  return api.post('/geo/cities', params);
};
